<template>
  <div>
    <i v-if="!disabled" class="fa fa-trash fa-danger fa-lg" @click="onShowModal"/>
    <i v-else class="fa fa-trash fa-secondary-disabled fa-lg"/>

    <Modal ref="delete_language"
           @onClose="closeModal"
           :values="modalValues">
      <template slot="footer">
        <b-button variant="danger" data-dismiss="modal" :disabled="spinners.isSaving" @click='onDelete()'>
          <b-spinner v-if="spinners.isSaving" type="grow" small/>{{ $t('global.delete') }}</b-button>
        <b-button variant="info" @click="closeModal()" class="ml-2">{{ $t('global.cancel') }}</b-button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/views/Shared/Modal';
import { mapActions } from 'vuex';
import VT from '@/store/types';

export default {
  mounted() {},
  props: {
    id: {
      value: String,
      required: true
    },
    disabled: {
      value: String,
      required: false
    },
  },
  data() {
    return {
      spinners: {
        isSaving: false,
      },
      isDisabled: true,
      modalValues: {
        id: 'delete_language',
        title: this.$t('global.delete_language'),
        body: this.$t('global.delete_language_confirm_text'),
      },
    };
  },
  components: { Modal },
  computed: {},
  methods: {
    ...mapActions('Languages', [
      VT.LANGUAGE_DELETE,
    ]),
    onShowModal() {
      this.$refs['delete_language'].show();
    },
    closeModal() {
      this.$refs['delete_language'].hide();
    },
    onDelete() {
      this.spinners.isSaving = true;
      this.LANGUAGE_DELETE(this.id).then(() => {
        this.alertSuccess();
        this.spinners.isSaving = false;
        this.closeModal();
        this.$emit('getData');
      }).catch(() => {
        this.alertError();
      });
    },
  }
};
</script>

<style scoped>
</style>
